/**
 * CheckCircleIcon component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.color="#149DFF"] - The color of the icon.
 * @param {number} [props.size=16] - The size of the icon.
 * @returns {JSX.Element} The CheckCircleIcon component.
 */
const CheckCircleIcon = ({ color, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99961 14.4016C11.5342 14.4016 14.3996 11.5362 14.3996 8.00156C14.3996 4.46694 11.5342 1.60156 7.99961 1.60156C4.46499 1.60156 1.59961 4.46694 1.59961 8.00156C1.59961 11.5362 4.46499 14.4016 7.99961 14.4016ZM11.0849 6.55447C11.2798 6.28647 11.2205 5.91122 10.9525 5.71632C10.6845 5.52142 10.3093 5.58067 10.1144 5.84866L7.32736 9.68079L5.82387 8.1773C5.58956 7.94298 5.20966 7.94298 4.97535 8.1773C4.74103 8.41161 4.74103 8.79151 4.97535 9.02583L6.97535 11.0258C7.09942 11.1499 7.2716 11.2134 7.44654 11.1997C7.62148 11.186 7.78164 11.0964 7.88485 10.9545L11.0849 6.55447Z"
        fill={color ?? "#149DFF"}
      />
    </svg>
  );
};

export default CheckCircleIcon;
